import { useEffect } from 'react'

import CoinIcon from 'ui/icons/coins.svg'

import c from './assets/scss/coins.module.scss'

export const Coins = () => {
    useEffect(() => {
        const handler = () => {
            const el = document.createElement('div')
            el.className = c.component
            el.innerHTML = `<span>+1</span><img src="${CoinIcon}" alt="coin"/>`

            // Параметры блока 200×50 для вылета монет
            const block = {
                x: window.innerWidth / 2 - 100, // здесь двигаем блок по горизонтали
                y: window.innerHeight / 2 - 225, // здесь двигаем блок по вертикали
                width: 200,
                height: 50,
            }

            // Случайная позиция внутри блока
            const randomX = block.x + Math.random() * block.width
            const randomY = block.y + Math.random() * block.height

            el.style.left = `${randomX}px`
            el.style.top = `${randomY}px`

            document.body.appendChild(el)

            // Удаляем после завершения анимации
            el.addEventListener('animationend', () => {
                el.remove()
            })
        }

        window.addEventListener('gg:coin-pop', handler)
        return () => window.removeEventListener('gg:coin-pop', handler)
    }, [])

    return null
}
